<template>
    <div v-if="canPurchaseRenewal()">
        <div class="main-title"><h2>{{ getTranslation('front', 'subscription_renewal_box_title') }}</h2></div>
        <div class="row justify-content-center mb-4">
            <div class="col-md-12">
                <div class="licenses__wrapper details-panel details-panel__white py-0 mt-0">
                    <div class="order-summary__body mb-5">
                        <template v-for="product in products" v-if="leaseProlongPrice[product.id]">
                            <div class="lease-prolong-row" v-if="leaseProlongPrice[product.id]">
                                <lease-prolong v-bind:product="product.id"></lease-prolong>
                            </div>

                        </template>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>


<script>
    export default {
        methods: {
            canPurchaseRenewal() {
                return this.checkCanPurchaseLeaseProlong;
            },
            addToCart(product) {
                this.$store.commit('toggleLeaseProlong', product.id);
            }
        },
        computed: {
            status: {
                get () {
                    let self = this;
                    let status = {};
                    _.forOwn(this.products, function(product, productId) {
                        status[product.id] = false;
                        if (!_.isNil(self.$store.state.cart.leaseProlong[product.id])) {
                            status[product.id] = self.$store.state.cart.leaseProlong[product.id].status || false;
                        }
                    });
                    return status;
                },
                set (val) {
                    //
                }
            },
            checkCanPurchaseLeaseProlong() {
                let canPurchase = false;
                let self = this;
                _.forOwn(this.products, function(product, productId) {
                    if (!_.isNil(self.leaseProlong[productId]) && self.isTruss4Product(productId)) {
                        canPurchase = true;
                    }
                });

                return canPurchase;
            },
            leaseProlongPrice() {
                let self = this;
                let totalPrice = {};
                _.forOwn(this.products, function(product, productId) {
                    totalPrice[productId] = 0;
                    if (_.isNil(self.$store.state.cart.leaseProlong[productId])) {
                        totalPrice[productId] = 0;
                    } else if (_.isNil(self.$store.state.cart.leaseProlong[productId].info)) {
                        totalPrice[productId] = 0;
                    } else {
                        _.forOwn(self.$store.state.cart.leaseProlong[productId].info, function(pr, key) {
                            totalPrice[productId] += self.getProgramPrice(pr.id, '', 'cloud_time_quantity', productId, pr.quantity)
                        });
                    }
                });
                return totalPrice;
            },
        },
        data() {
            return {
                products: window.jsonProducts,
                navigation: window.quickNavigationUrls,
                leaseProlong: JSON.parse(window.leaseProlong),
            };
        }
    }
</script>
